export default __webpack_public_path__ + "static/media/documents.4593ab8d.svg";